import React from 'react';

/**
 * History / recent-search clock glyph (e.g. **`SearchSuggest`** suggestion row leading icon).
 */
const IconHistory: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='16'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    className={`icon icon-history${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm12-336h-24a12 12 0 0 0-12 12v132.1l103.5 75.2a12 12 0 0 0 16.8-2.6l14.1-19.4a12 12 0 0 0-2.6-16.8L280 247.9V132a12 12 0 0 0-12-12z'
      fill=''
    />
  </svg>
);

export default IconHistory;
